"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountEditor = void 0;
var jquery_1 = __importDefault(require("jquery"));
var tax_75_svg_1 = __importDefault(require("@ClientAssets/icons/color/tax-75.svg"));
var OverlayEditorLayout_1 = require("Common/OverlayEditorLayout/OverlayEditorLayout");
var Discount_util_1 = require("@CommonFrontendBackend/Discount/Discount.util");
var QuoteAccountSettingsUpdater_1 = require("../../QuoteAccountSettingsUpdater");
var DiscountEditor = (function () {
    function DiscountEditor(make, createUi, $timeout, discountService, onDiscountUpdated) {
        var _this = this;
        this.discountService = discountService;
        this.onDiscountUpdated = onDiscountUpdated;
        this.show = function (quoteCurrencyFormatter) {
            _this.discountsListComponent = _this.createDiscountList(quoteCurrencyFormatter);
            var discountEditor = _this.make(OverlayEditorLayout_1.OverlayEditorLayout, {
                iconSrc: tax_75_svg_1.default,
                listComponent: _this.discountsListComponent,
                createNewItem: _this.createNewDiscountItem,
                title: "Discounts",
                description: "Save discounts you use regularly, and save time\n                    when you create quotes",
                isValid: function () { return true; },
            });
            discountEditor.show();
        };
        this.createDiscountList = function (quoteCurrencyFormatter) {
            return _this.createUi(require("./DiscountEditor.html"), {
                discounts: _this.discountService.getAllLiveDiscounts(),
                removeDiscountById: function (id) {
                    _this.discountService.removeDiscountById(id);
                    _this.apiUpdater.debouncedApiUpdate();
                    _this.discountsListComponent.discounts = _this.discountService.getAllLiveDiscounts();
                },
                currencySymbol: quoteCurrencyFormatter.getSymbol(),
                onDiscountTypeClick: function (id, type) {
                    _this.discountService.updateDiscountByPropName(id, "type", type);
                    _this.apiUpdater.debouncedApiUpdate();
                    var updatedDiscount = _this.discountService.findDiscountById(id);
                    _this.onDiscountUpdated(updatedDiscount);
                },
                onInputChange: function (id, val) {
                    _this.discountService.updateDiscountByPropName(id, "units", val);
                    _this.apiUpdater.debouncedApiUpdate();
                    var updatedDiscount = _this.discountService.findDiscountById(id);
                    _this.onDiscountUpdated(updatedDiscount);
                },
                onNameChange: function () {
                    _this.apiUpdater.debouncedApiUpdate();
                },
            });
        };
        this.createNewDiscountItem = function () {
            _this.discountService.addNewDiscount((0, Discount_util_1.createNewDiscountItem)());
            _this.apiUpdater.debouncedApiUpdate();
            _this.discountsListComponent.discounts = _this.discountService.getAllLiveDiscounts();
            return _this.$timeout(function () { return (0, jquery_1.default)(".discount-item").last().find(".name").trigger("focus"); }, 20);
        };
        this.make = make;
        this.createUi = createUi;
        this.$timeout = $timeout;
        this.apiUpdater = make(QuoteAccountSettingsUpdater_1.QuoteAccountSettingsUpdater, {
            settingsName: "discounts",
            transformFunction: function (_a) {
                var id = _a.id, name = _a.name, type = _a.type, amount = _a.amount, isEnabled = _a.isEnabled, isDeleted = _a.isDeleted;
                return ({
                    id: id,
                    name: name,
                    type: type,
                    amount: amount,
                    isEnabled: isEnabled,
                    isDeleted: isDeleted,
                });
            },
        });
    }
    return DiscountEditor;
}());
exports.DiscountEditor = DiscountEditor;
